import { render, staticRenderFns } from "./RemoveRequirement.vue?vue&type=template&id=376dd206&"
import script from "./RemoveRequirement.vue?vue&type=script&lang=ts&"
export * from "./RemoveRequirement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports